import firebase from 'firebase/app'
import "firebase/auth"
import 'firebase/storage';
require("firebase/firestore");



const app = firebase.initializeApp({
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID
})

export var db = firebase.firestore();
export var storage = firebase.storage();
export const auth = app.auth()


// currently unused
export var googleProvider = new firebase.auth.GoogleAuthProvider();

export default app